import { useState } from "react";
import { toast } from "sonner";
import { Loader2, ShieldAlert, CheckCircle2 } from "lucide-react";
import Navbar from "@/components/Navbar";
import { musicApi, errMsg } from "@/lib/musicApi";

const F = ({ label, children }) => <label className="block text-xs font-semibold text-white/60">{label}<div className="mt-1">{children}</div></label>;
const cls = "w-full rounded-lg border border-white/10 bg-white/[0.04] px-3 py-2 text-sm text-white outline-none focus:border-[#7AD7FF]/60";

// Public rights-holder reporting / takedown form for AI Music Studio outputs.
export default function MusicTakedown() {
  const [f, setF] = useState({ name: "", email: "", work: "", track_reference: "", details: "", good_faith: false });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { setDone((await musicApi.reportTakedown(f)).id); } catch (err) { toast.error(errMsg(err, "Could not send the report")); }
    setBusy(false);
  };
  return (
    <div className="min-h-screen bg-[#070707] text-white">
      <Navbar />
      <div className="mx-auto max-w-xl px-5 py-12">
        <ShieldAlert className="text-[#FFB547]" />
        <h1 className="mt-3 font-display text-3xl font-black">Report AI music / takedown request</h1>
        <p className="mt-2 text-sm text-white/50">If you hold rights to a work and believe a track made with our AI Music Studio infringes them, tell us. We review every report and remove content where appropriate.</p>
        {done ? (
          <div className="mt-8 flex items-start gap-3 rounded-2xl border border-[#C8FF4D]/30 bg-[#C8FF4D]/10 p-5 text-sm" data-testid="takedown-success"><CheckCircle2 className="shrink-0 text-[#C8FF4D]" /> Report received (ref {done}). We'll contact you by email.</div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="takedown-form">
            <div className="grid gap-4 sm:grid-cols-2">
              <F label="Your name"><input required value={f.name} onChange={set("name")} className={cls} data-testid="takedown-name" /></F>
              <F label="Email"><input required type="email" value={f.email} onChange={set("email")} className={cls} data-testid="takedown-email" /></F>
            </div>
            <F label="Your work (title, artist, owner)"><input required value={f.work} onChange={set("work")} className={cls} data-testid="takedown-work" /></F>
            <F label="Where you found the AI track (link or description)"><input value={f.track_reference} onChange={set("track_reference")} className={cls} data-testid="takedown-track" /></F>
            <F label="Details"><textarea required minLength={10} rows={5} value={f.details} onChange={set("details")} className={cls} data-testid="takedown-details" /></F>
            <label className="flex items-start gap-2 text-xs text-white/60"><input type="checkbox" checked={f.good_faith} onChange={set("good_faith")} data-testid="takedown-good-faith" className="mt-0.5" /> I believe in good faith that this use isn't authorized by the rights holder, and the information is accurate.</label>
            <button disabled={busy || !f.good_faith} data-testid="takedown-submit" className="flex items-center gap-2 rounded-full bg-[#7AD7FF] px-5 py-2.5 text-sm font-black text-black disabled:opacity-40">{busy && <Loader2 size={14} className="animate-spin" />} Send report</button>
          </form>
        )}
      </div>
    </div>
  );
}
